var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-descriptions",
        { attrs: { column: 3 } },
        [
          _c("el-descriptions-item", { attrs: { label: "供应商" } }, [
            _vm._v(_vm._s(_vm.trainsInfo.merchantName)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "供应商电话" } }, [
            _vm._v(_vm._s(_vm.trainsInfo.merchantPhoneNumber)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "车型" } }, [
            _vm._v(_vm._s(_vm.trainsInfo.carType)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "班次时间" } }, [
            _vm._v(_vm._s(_vm.trainsInfo.flightPlanTime)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "司机信息" } }, [
            _vm._v(
              _vm._s(_vm.trainsInfo.driverName) +
                _vm._s(_vm.trainsInfo.driverMobilePhone)
            ),
          ]),
          _c(
            "el-descriptions-item",
            { attrs: { label: "车牌信息" } },
            [
              _c("yd-link", {
                attrs: {
                  permi: "vehicle_view",
                  value: _vm.trainsInfo.plateNumber,
                  type: "vehicleDetail",
                  query: { id: _vm.trainsInfo.carId },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }